import React, { useContext } from 'react';
import { AppContext } from '../../../context';
import LexipolAdminRoutes from './LexipolAdmin';
import AgencyAdminRoutes from './AgencyAdmin';

const Templates: React.FC = () => {
  const { isLexipolStaff } = useContext(AppContext);

  return isLexipolStaff ? <LexipolAdminRoutes /> : <AgencyAdminRoutes />;
};

export default Templates;
